import deburr from "lodash.deburr";

export const removeAccentuatedChars = (text: string) => {
    return deburr(text);
};

export const normalizeChars = (text: string) => {
    return removeAccentuatedChars(text.toLowerCase());
};
